import React from "react";
import { Control, Controller } from "react-hook-form";
import RadioSelect from "../base/RadioSelect";

interface Props {
  control: Control<any, any>;
  fieldName: string;
  label: string;
  required?: boolean;
  disabled?: boolean;
  onChange?: (value: boolean) => void;
}

const FormRadio: React.FC<Props> = (props) => {
  const { control, fieldName, label, required, disabled, onChange } = props;

  const handleOnChange = (value: any) => {
    if (onChange) {
      onChange(value);
    }
  };

  return (
    <Controller
      name={fieldName}
      control={control}
      rules={{ required: required }}
      render={({ field: { onChange, value } }) => (
        <RadioSelect
          label={label}
          value={value || null}
          disabled={disabled}
          onChange={(value) => {
            onChange(value);
            handleOnChange(value);
          }}
        />
      )}
    />
  );
};

export default FormRadio;
